import { render, staticRenderFns } from "./AddTransaction.component.vue?vue&type=template&id=88ec8f5a"
import script from "./AddTransaction.component.vue?vue&type=script&lang=ts"
export * from "./AddTransaction.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports